import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { ControlDetailOverviewModel } from "@app/controls/detail-overview/ControlDetailOverviewModel";
import { ControlDetailOverviewDataService } from "@app/controls/detail-overview/control-detail-overview.data.service";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { EffButtonComponent } from "../eff-button/eff-button.component";
import { EffSaveButtonComponent } from "../eff-save-button/eff-save-button.component";

@Component({
    selector: "eff-step-header",
    templateUrl: "./eff-step-header.component.html",
    styleUrls: ["./eff-step-header.component.scss"],
    imports: [TranslatePipe, EffButtonComponent, EffSaveButtonComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class EffStepHeaderComponent implements OnInit {
    private _controlService = inject(ControlDetailOverviewDataService);

    @Input() title: string;
    @Input() controlGuid: string;
    @Input() saveButtonLabel: string;
    @Input() hideSaveButton: boolean = false;
    @Input() showNonOccurrenceWarningArea: boolean = false;

    @Output() onSaveChanges: EventEmitter<any> = new EventEmitter();
    @Output() onShowInstructions: EventEmitter<any> = new EventEmitter();

    controlInfo: ControlDetailOverviewModel = undefined;

    async ngOnInit() {
        await this.loadControlInfo();
    }

    async loadControlInfo() {
        this._controlService
            .getControlOverview(this.controlGuid)
            .subscribe((info) => (this.controlInfo = info));
    }

    onSave() {
        this.onSaveChanges.emit();
    }

    clickInstructions() {
        this.onShowInstructions.emit();
    }
}
